import React,{Component} from "react";
export default function footer(){
    return(
        <footer>
  <div class="social-media">
    <a href="#"><i class="fab fa-facebook-f"></i></a>
    <a href="#"><i class="fab fa-twitter"></i></a>
    <a href="#"><i class="fab fa-instagram"></i></a>
    <a href="#"><i class="fab fa-linkedin-in"></i></a>
  </div>
  <p>&copy; <time dateTime="1914-12-20">25-12-2023</time> . All rights reserved.</p>
</footer>
    )
}